import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/tokens.css'
import './styles/app.css'
import './styles/schedule.css'
import './styles/inventory.css'
import './styles/calendar.css'
import './styles/tree.css'
import './styles/connectivity.css'

/**
 * The cache layer, not a hand-rolled outbox.
 *
 * A workshop has patchy wifi, so refetching on reconnect matters more here than
 * in an office tool — but true offline is a different and much harder problem
 * than responsiveness, and §10.3 does not ask for it. When it does, this is the
 * seam it goes behind.
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10_000,
      refetchOnWindowFocus: true,
      retry: (failureCount, error) =>
        // 401 and 404 are answers, not failures. Retrying them just delays the
        // message the user needs to read.
        failureCount < 2 && !/\b(401|404)\b/.test(String(error)),
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
